import { keepPreviousData } from '@tanstack/react-query';
import { useRepositoryQuery } from '@mews-commander/data-access';

const ACCOUNTS_EXTENT = {
    profiles: true,
};

export const useAccountsByOwnerId = (ownerId = '') =>
    useRepositoryQuery(
        'accounts',
        'getAll',
        {
            accountIds: [ownerId],
            extent: ACCOUNTS_EXTENT,
        },
        {
            enabled: !!(ownerId && ownerId.length),
            placeholderData: keepPreviousData,
            refetchOnMount: 'always',
        }
    );
